/**
 * From flat object to nested object
 */
export const flattenToNested = (flatObj) => {
  const nested = {}

  for (const key in flatObj) {
    const keys = key.split('.') // split by dot
    keys.reduce((acc, part, idx) => {
      if (idx === keys.length - 1) {
        acc[part] = flatObj[key] // last key, assign value
      } else {
        acc[part] = acc[part] || {} // create nested object if doesn't exist
      }
      return acc[part]
    }, nested)
  }

  return nested
}
